export default __webpack_public_path__ + "static/media/Arm-bands of the Bloodhunter.9486c868.jpg";